import { useQuery, useSuspenseQuery } from '@tanstack/react-query'

import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import { paymentCategoryListSchema } from '../../../common/validations/paymentCategory'

import { get } from 'api/apiClient'

const params = (contractUUID: string) => ({
  queryKey: [`${API_ENDPOINTS.CONTRACTS}/${contractUUID}/payment-categories`],
  queryFn: () =>
    get(
      `${API_ENDPOINTS.CONTRACTS}/${contractUUID}/payment-categories`,
      paymentCategoryListSchema
    ),
})

export const useAPIGetContractPaymentCategories = (contractUUID: string) =>
  useQuery(params(contractUUID))

export const useAPIGetContractPaymentCategoriesSuspense = (
  contractUUID: string
) => useSuspenseQuery(params(contractUUID))
